import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import 'firebase/compat/auth';
import 'firebase/compat/functions';

import env from './env';

const config =  {
  apiKey: env('FIREBASE_API_KEY'),
  authDomain: env('FIREBASE_AUTH_DOMAIN'),
  databaseURL: env('FIREBASE_DATABASE_URL'),
  projectId: env('FIREBASE_PROJECT_ID'),
  storageBucket: env('FIREBASE_STORAGE_BUCKET'),
  messagingSenderId: env('FIREBASE_MESSAGING_SENDER_ID'),
};

firebase.initializeApp(config);

let functionsInstance;
const isEmulator = env('CLOUD_FUNCTIONS_EMULATOR') === 'true';

if(isEmulator) {
  functionsInstance = firebase.app().functions('asia-northeast1');
  functionsInstance.useFunctionsEmulator('http://localhost:5000');
} else {
  functionsInstance = firebase.app().functions(env('FUNCTIONS_DOMAIN') || 'asia-northeast1');
}

export const functions = {
  httpsCallable: (name, options) => functionsInstance.httpsCallable(isEmulator ? name : name.toLowerCase(), options)
};

export default firebase;
